import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { baseFiltersOptions } from "~/components/FiltersMenu/types";
import { APPLY_SINGLE_FILTER_BTN, CLEAR_SINGLE_FILTER_BTN, SINGLE_FILTER_CARD } from "~/constants/testIDs";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const SingleFilterContainer = (param)=>{
    let { currentFilter, currentCustomField, onApplyClick, onClearClick, children, hasValues = true } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    var _currentCustomField_name;
    const label = (_currentCustomField_name = currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.name) !== null && _currentCustomField_name !== void 0 ? _currentCustomField_name : baseFiltersOptions[currentFilter].label;
    const Icon = baseFiltersOptions[currentFilter].icon;
    const testId = (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.id) ? "".concat(SINGLE_FILTER_CARD, "-").concat(currentCustomField.name) : "".concat(SINGLE_FILTER_CARD, "-").concat(currentFilter);
    return /*#__PURE__*/ _jsxs("div", {
        className: searchImprovements ? "p-0" : "px-3 pb-2 pt-4",
        "data-testid": testId,
        children: [
            !searchImprovements && /*#__PURE__*/ _jsxs("div", {
                className: "mb-3 flex items-center",
                children: [
                    !!Icon && /*#__PURE__*/ _jsx(Icon, {
                        className: "size-4 text-grey-10"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ml-1 truncate text-14 font-medium text-grey-10",
                        children: label
                    })
                ]
            }),
            children,
            searchImprovements ? // This is a work around for the Select dropdown bug. Select needs atleast 1px below the component
            // to render the dropdown properly.
            /*#__PURE__*/ _jsx("div", {
                className: "h-px"
            }) : /*#__PURE__*/ _jsxs("div", {
                className: "mt-4 flex justify-end gap-3",
                children: [
                    onClearClick && /*#__PURE__*/ _jsx(Button, {
                        appearance: "ghost",
                        color: "grey",
                        disabled: !hasValues,
                        "data-testid": "".concat(CLEAR_SINGLE_FILTER_BTN, "-").concat(label),
                        onClick: onClearClick,
                        size: "medium",
                        children: "Clear"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "filled",
                        color: "blue",
                        disabled: !hasValues,
                        "data-testid": "".concat(APPLY_SINGLE_FILTER_BTN, "-").concat(label),
                        onClick: onApplyClick,
                        size: "medium",
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
